import { ReactNode } from "react";
import { useParams } from "react-router-dom";
import GridList, { GridListDataSource } from "./GridList";
import Heading from "./Heading";

interface SolutionTemplatesProps {
    dataSource: GridListDataSource[];
    title?: ReactNode;
    description?: ReactNode;
    navigateState?: object;
}

export default function SolutionTemplates(props: SolutionTemplatesProps) {
    const { envId } = useParams();

    return (
        <>
            {/* Header */}
            {props.title && props.description && props.dataSource.length > 0 &&
                <Heading
                    title={props.title}
                    description={props.description}
                    level={4}
                />
            }

            {/* Templates */}
            {
                props.dataSource.length > 0 &&
                <GridList
                    dataSource={props.dataSource}
                    navigateState={
                        props.navigateState ?
                            props.navigateState :
                            envId ?
                                { state: { envId } } :
                                undefined
                    }
                    itemsInRow={4} />
            }
        </>
    );

}